module.exports = __webpack_public_path__ + "img/step1.601021df.png";